import { extend, noop } from 'lodash';
import ApplicationController from '../application_controller';
/*
  Componente para la selección de items que se importarán desde la opción
  de importar ítems del cuaderno en el segundo paso después de seleccionar el fichero.
*/
/* global Mn, $, I18n, swal */
const SeleccionImportarItemsCuaderno = Mn.View.extend({
  template: noop,
  events: {
    'click .boton-seleccionar-todo': 'habilitarSubmit',
    'click .importar-check': 'habilitarSubmit',
    'click .check-origen': 'habilitarSiguiente',
    'click .btn-importar-items': 'solicitarConfirmacion',
  },
  // Habilita el botón para hacer el submit del formulario
  habilitarSubmit() {
    const disabled = this.$el.find('.importar-check:checkbox:checked').map(
      function valores() {
        return $(this).val();
      },
    ).get().length === 0;
    this.$el.find('.btn-importar-items').prop('disabled', disabled);
  },
  habilitarSiguiente() {
    this.$el.find('.btn-siguiente').prop('disabled', false);
  },
  // Solicita la confirmación antes de importar los ítems
  solicitarConfirmacion(e) {
    const $boton = $(e.currentTarget);
    // Si marcan el botón para que no confirme, continuamos
    if ($boton.data('confirmar') === false) {
      return true;
    }
    e.preventDefault();
    e.stopPropagation();
    swal(
      {
        title: I18n.t('Importar_items.aviso_titulo'),
        text: I18n.t('Importar_items.aviso_descripcion'),
        type: 'warning',
        html: true,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: '#fe1d12',
        confirmButtonText: 'Aceptar',
        closeOnConfirm: true,
      },
      // eslint-disable-next-line func-names, prefer-arrow-callback
      function (isConfirmed) {
        if (isConfirmed) {
          // requestSubmit() para que lo trate Turbo
          $boton.closest('form.seleccionar-items')[0].requestSubmit($boton[0]);
        }
      },
    );
    return false;
  },
});

export default class extends ApplicationController {
  connect() {
    const options = extend({
      el: this.element,
    }, $(this.element).data());

    this.component = new SeleccionImportarItemsCuaderno(options);
    this.component.render();
  }
}
